import { CarCreate, UpdateCar } from "../../types";
import apiClient from "../apiClient";
import { VehicleFilters } from "./types.api";

export const getVehicles = async (params: VehicleFilters) => {
  const response = await apiClient.get("vehicles/getAll", { params });
  return response.data;
};

export const addVehicle = async (params: CarCreate) => {
  await apiClient.post('vehicles/addVehicle', params);
};

export const updateVehicle = async (params: Partial<UpdateCar>) => {
  await apiClient.put('vehicles/updateVehicle', params);
}

export const deleteVehicle = async (carId: string, images: string[]) => {
  await apiClient.delete(`/vehicles/removeVehicle/${carId}`, {
    data: JSON.stringify({
      images,
    }),
  });
};
